import React from 'react';

import { ClipboardCheckIcon } from './ClipboardCheckIcon';
import cn from './styles.module.scss';

type SurveySeasonBadgeProps = {
  label: string;
};

export function SurveySeasonBadge({ label }: SurveySeasonBadgeProps) {
  return (
    <span className={cn.badge} data-testid="surveySeasonBadge">
      <span className={cn.badgeIcon}>
        <ClipboardCheckIcon size={14} />
      </span>
      {label}
    </span>
  );
}
